import { ChannelAssignmentDropDown, ChannelSelectionDropDown, useMyCurrentChannel } from 'open-modules/zdf/component/channels/channel-dropdown';
import { InstanceManagerConfig, NewInstance, NewInstancePostCreationTriggerProps } from "feature/editorial-dash/question-topic-manager";
import { useEffect } from "react";
import { View } from "react-native";
import { Feature } from "util/stdtypes";

export const ChannelSelectionFeature: Feature<InstanceManagerConfig, {}> = {
    name: "Channel Selection/Reassignment",
    key: "editorialdashchannelselection",
    config: {
        newInstanceWidgets: [NewInstanceChannelWidget],
        instanceBottomLeftWidgets: [ChannelAssignmentDropDown],
        newInstancePostCreateTriggers: [assignChannelAfterInstanceCreation],
    },
};
// Note: Used to only show this for structures that need channel assignments
const allowedStructures = ["question", "topic"];

export type NewInstanceWithChannel = NewInstance & {
    channelKey: string;
}

async function assignChannelAfterInstanceCreation(props: NewInstancePostCreationTriggerProps): Promise<void> {
    if (!allowedStructures.includes(props.structureKey)) {
        return;
    }
    const newInstanceWithChannel = props.instance as NewInstanceWithChannel;
    await props.datastore.callServerAsync("channel", "assignContentToChannel", {
        instanceKey: props.instanceKey,
        channelKey: newInstanceWithChannel.channelKey,
        structureKey: props.structureKey,
    });
}

export function NewInstanceChannelWidget({ structureKey, instance, setInstance }) {
    const currentChannel = useMyCurrentChannel();

    useEffect(() => {
        if (currentChannel != null) {
            setInstance((instance) => ({ ...instance, channelKey: currentChannel.key }));
        }
    }, [currentChannel]);

    if (!allowedStructures.includes(structureKey)) {
        return;
    }

    return (
        <View>
            <ChannelSelectionDropDown />
        </View>
    );
}